import { connect } from 'react-redux';
import { withBiEvent } from 'shared/bi/send-bi-event';
import autobind from 'core-decorators/lib/autobind';

import decorate from 'widget/utils/decorate';
import { notForPreview } from 'widget/utils/not-for-preview';

import { selectVideo } from 'widget/redux/client/actions/select-video';
import { openFullScreenOverlay } from 'shared/utils/open-overlay';

import InFrameActions from './in-frame';

// In Expanded View mode click on a thumbnail should select video in widget, not show overlay.
// Overlay is only used to play videos in compact layout.
@connect(null, {
  selectVideo,
})
@decorate(InFrameActions)
export default class InOverlayActionCallbacks extends React.Component {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
    videoSource: React.PropTypes.string,

    selectVideo: React.PropTypes.func,
    onSelectOrPlay: React.PropTypes.func,
  };

  @autobind
  @notForPreview
  showVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}`);
  }

  @autobind
  @withBiEvent('widget.vid.clicked', function () {
    const { channelId, videoId, videoSource } = this.props;

    return {
      channelID: channelId,
      videoID: videoId,
      videoType: videoSource,
    };
  })
  @notForPreview
  playVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}?autoplay=true`);
  }

  render() {
    const inFrameActions = _.omit(this.props, this.propTypes);

    return React.cloneElement(this.props.children, {
      ...inFrameActions,
      onPlayRequest: this.playVideoAtOverlay,
      onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-action-callbacks/in-overlay.js